import React from 'react';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InstagramIcon from '@mui/icons-material/Instagram';
import TelegramIcon from '@mui/icons-material/Telegram';
import PhoneIcon from '@mui/icons-material/Phone';
import MessageIcon from '@mui/icons-material/Message';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import LinkIcon from '@mui/icons-material/Link';
import EmailIcon from '@mui/icons-material/Email';

const MessengerIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.36 2 2 6.13 2 11.7c0 2.9 1.15 5.46 3.12 7.33V22l2.86-1.57c1.27.35 2.61.54 4.02.54 5.64 0 10-4.13 10-9.7C22 6.13 17.64 2 12 2zm1.29 12.19l-2.3-2.45-4.48 2.45 4.92-5.23 2.35 2.45 4.43-2.45-4.92 5.23z"/>
  </svg>
);

const TwitterXIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);

export const CHANNEL_TYPES = [
  { value: 'whatsapp', label: 'WhatsApp', icon: <WhatsAppIcon />, color: '#25D366' },
  { value: 'messenger', label: 'Messenger', icon: <MessengerIcon />, color: '#0084FF' },
  { value: 'instagram', label: 'Instagram', icon: <InstagramIcon />, color: '#E4405F' },
  { value: 'telegram', label: 'Telegram', icon: <TelegramIcon />, color: '#0088cc' },
  { value: 'linkedin', label: 'LinkedIn', icon: <LinkedInIcon />, color: '#0077b5' },
  { value: 'twitter', label: 'X (Twitter)', icon: <TwitterXIcon />, color: '#000000' },
  { value: 'email', label: 'Email', icon: <EmailIcon />, color: '#EA4335' },
  { value: 'phone', label: 'Phone', icon: <PhoneIcon />, color: '#4CAF50' },
  { value: 'sms', label: 'SMS', icon: <MessageIcon />, color: '#2196F3' },
  { value: 'link', label: 'Custom Link', icon: <LinkIcon />, color: '#607D8B' },
];

// Use real favicons via Google's favicon API — always shows the official brand logo
export const AI_PROVIDER_ICONS = {}; // kept for legacy compat; AiProviderButton uses favicon URLs directly

export const AI_PROVIDERS = [
  { value: 'chatgpt',    label: 'ChatGPT',    color: '#10A37F', url: 'https://chat.openai.com/',      favicon: 'https://www.google.com/s2/favicons?domain=chat.openai.com&sz=32' },
  { value: 'claude',     label: 'Claude',     color: '#D97706', url: 'https://claude.ai/',            favicon: 'https://www.google.com/s2/favicons?domain=claude.ai&sz=32' },
  { value: 'grok',       label: 'Grok',       color: '#000000', url: 'https://grok.com/',             favicon: 'https://www.google.com/s2/favicons?domain=grok.com&sz=32' },
  { value: 'perplexity', label: 'Perplexity', color: '#20B2AA', url: 'https://www.perplexity.ai/',   favicon: 'https://www.google.com/s2/favicons?domain=perplexity.ai&sz=32' },
  { value: 'gemini',     label: 'Gemini',     color: '#4285F4', url: 'https://gemini.google.com/',   favicon: 'https://www.google.com/s2/favicons?domain=gemini.google.com&sz=32' },
  { value: 'google_ai', label: 'Google AI',  color: '#4285F4', url: 'https://www.google.com/search?udm=50&aep=11', favicon: 'https://www.google.com/s2/favicons?domain=google.com&sz=32' },
];
